// --- Dependencies -------------------------------------------------------------------------------
import type { CSSProperties } from "react";
// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    /** Screen-owned class carrying the size and radius of the card this stands in for. */
    className?: string;

    style?: CSSProperties;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * A placeholder shaped like the thing that is loading. It brings only the brand shimmer — geometry
 * stays with the screen so the placeholder and the real card can never drift apart.
 */
export default function Skeleton({ className, style }: Props) {
    return <div className={`skeleton${className ? ` ${className}` : ""}`} style={style} aria-hidden="true" />;
}
